import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UdxSpinnerService } from '@upr-web-primer/udx-spinner';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-birthday-discount',
  templateUrl: './birthday-discount.component.html',
  styleUrls: ['./birthday-discount.component.scss'],
  standalone: false,
})
export class BirthdayDiscountComponent implements OnInit {
  pageLabels: any;
  @ViewChild('birthDayContainer', { read: ViewContainerRef, static: true })
  birthDayContainer!: ViewContainerRef;
  constructor(
    @Inject('AppRoutes') public appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    private readonly commonUtilityService: CommonUtilityService,
    private readonly spinner: UdxSpinnerService,
    private readonly title: Title,
  ) {
    this.pageLabels = this.commonUtilityService.getResolvedPageData();
    this.title.setTitle(this.pageLabels?.['page.birthdayDiscount']);
  }
  ngOnInit(): void {
    this.getContent();
  }

  /**
   * goToPage - It will redirect to the specified route
   * @param type : specify which route to navigate
   */

  goToPage(type: any): any {
    switch (type) {
      case this.globalDefault.BIRTHDAY_DISCOUNT:
        this.commonUtilityService.changeRoute(this.appRoutes.DASHBOARD);
        break;
    }
  }

  goToHomepage(): void {
    this.commonUtilityService.changeRoute(this.appRoutes.DASHBOARD);
  }

  getContent(): void {
    this.spinner.show();
    this.commonUtilityService
      .fetchTridionContents('birthday-content')
      ?.subscribe((data: any) => {
        if (data && data?.length > 0)
          this.initializeUI(data?.[0].data?.elements);
      });
  }
  initializeUI(elements: any): void {
    this.birthDayContainer?.clear();
    this.spinner.hide();
    this.commonUtilityService.loadTridionUtility(
      this.birthDayContainer,
      elements,
    );
  }
}
